export default __webpack_public_path__ + "static/media/contact.942d0144.png";